import PhotoSearchCheckoutLayout from './PhotoSearchCheckoutLayout';

export default PhotoSearchCheckoutLayout;
